import { render, staticRenderFns } from "./CartXsellItem.vue?vue&type=template&id=478838ec&scoped=true&lang=pug&"
import script from "./CartXsellItem.vue?vue&type=script&lang=js&"
export * from "./CartXsellItem.vue?vue&type=script&lang=js&"
import style0 from "./CartXsellItem.vue?vue&type=style&index=0&id=478838ec&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478838ec",
  null
  
)

export default component.exports